import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { AVIFHeadTextComponent } from './AVIFCommonComponents';
import {
  AVIFDetailCommonContainer,
  CodecDetailSubTitle,
} from './AVIFDetailCodec';
import chart1Img from 'public/asset/product/pulsar/05-AVIF/xl-2.png';
import chart2Img from 'public/asset/product/pulsar/05-AVIF/xl-3.png';
import { AVIFDefaultText } from 'global-styles';

const AVIFDetailResults = () => {
  return (
    <AVIFDetailResultsContainer>
      <AVIFHeadTextComponent>Results</AVIFHeadTextComponent>
      <CodecDetailSubTitle>Coding Efficiency</CodecDetailSubTitle>

      <div className="img-w">
        <ImgBackgroundWrapper isNormalUse>
          <Image src={chart1Img.src} alt="" objectFit="cover" layout="fill" />
        </ImgBackgroundWrapper>
      </div>
      <ResultsStyledDefaultText>
        Interpretation: For example, when avifenc(aom) has the same PSNR_Y score
        as libjpeg-turbo, avifienc(aom)&apos;s file size is 56.21% smaller than
        libjpeg-turbo.
      </ResultsStyledDefaultText>

      <div className="img-w">
        <ImgBackgroundWrapper isNormalUse>
          <Image src={chart2Img.src} alt="" objectFit="cover" layout="fill" />
        </ImgBackgroundWrapper>
      </div>
      <ResultsStyledDefaultText>
        The coding efficiency of pulsar-avif is not much different from the
        software AVIF encoders.
      </ResultsStyledDefaultText>
    </AVIFDetailResultsContainer>
  );
};

export default AVIFDetailResults;

const AVIFDetailResultsContainer = styled(AVIFDetailCommonContainer)`
  .img-w {
    position: relative;
    padding-top: 75%;
  }
`;

const ResultsStyledDefaultText = styled(AVIFDefaultText)`
  color: #313131;
  display: block;
  padding: 24px 0;
`;
